export enum CreatedByFlowBucket {
    All = '',
    Ots = 'ots',
    Lp = 'lp',
}
